<template>
    <div class="row">
        <div
            v-if="loading"
            class="lds-dual-ring"
        ></div>
        <div v-else class="col-lg-12 mb-4">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl">
                        To Do’s
                    </div>
                    <div class="buttons--row mb-4 mt-4">
                        <div class="search--block">
                            <button
                                class="search--block-btn"
                                type="submit"
                                @click.prevent="getTodoList"
                            ><img src="/img/svg/icons-search.svg" alt="">
                            </button>
                            <input
                                type="search"
                                name="search"
                                class="search--block-txt"
                                v-model="filters.search"
                                @input="handleSearch"
                            />
                        </div>
                        <div class="filter-wrap">
                            <label for="" class="reg-label mr-2">Filter:</label>
                            <div class="form-group form-group-2 mb-0">
                                <select
                                    class="custom-select"
                                    v-model="filters.status"
                                    @change="getTodoList"
                                >
                                    <option value="null" selected disabled>Select One</option>
                                    <option value="all">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="complete">Complete</option>
                                </select>
                            </div>
                        </div>
                        <div class="buttons-type-multiselect">
                            <div class="item" v-for="(option, index) in radioOptions" :key="option.id">
                                <input
                                    type="radio"
                                    class="rad"
                                    :id="option.id"
                                    :value="option.value"
                                    v-model="filters.type"
                                    @change="getTodoList"
                                >
                                <label :for="option.id">
                                    <div class="ttl">{{ option.label }}</div>
                                </label>
                            </div>
                        </div>
                        <a
                            href="/master-admin/to-do/create"
                            class="btn btn--outline-primary btn--middle"
                        >
                            + Add New
                        </a>
                    </div>
                    <div class="table-holder table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('title')">To Do<i
                                            class="fas fa-sort"></i></a>
                                    </nobr>
                                </th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('priority')">Priority<i
                                            class="fas fa-sort"></i></a>
                                    </nobr>
                                </th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)" @click.prevent="changeSortList('dead_line')">Deadline<i
                                            class="fas fa-sort"></i></a>
                                    </nobr>
                                </th>
                                <th>
                                    <nobr>
                                        <a href="javascript:void(0)">Status</a>
                                    </nobr>
                                </th>
                                <th class="text-right pr-4">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <template
                                v-for="todo in sortedTasks"
                            >
                                <ToDoListItem
                                    :todo="todo"
                                    :deletingTodo="deletingTodo"
                                    :list-of-todo="todoList"
                                    :users="listOfUsers"
                                    @delete="deleteTodo"
                                    @update-list="getTodoList"
                                />
                            </template>
                            <tr v-if="!todoList.length > 0">
                                <div class="box-ttl m-3">No results found</div>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        :currentPage="pagination.current_page"
                        :lastPage="pagination.last_page"
                        @changeItemsPerPage="changeItemsPerPage"
                        @changePage="changePage" />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import ToDoService from "./services/ToDoService";
import EyesShowModal from "../../../../../resources/js/components/EyesShowModal.vue";
import ActionModal from "../../../../../resources/js/components/ActionModal.vue";
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import AddNewItemModal from "../../../../../resources/js/components/AddNewItemModal.vue";
import Pagination from "../../../../../resources/js/components/Pagination.vue";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import PaginationHandler from "../../../../../resources/js/mixins/PaginationHandler";
import SortDirectionHandler from "../../../../../resources/js/mixins/SortDirectionHandler";
import ToDoListItem from "./ToDoListItem.vue";
import {createDebouncedFunction} from "../../../../../resources/js/plugins/debounce";

export default {
    name: 'ToDoList',
    components: {ToDoListItem, Pagination},
    mixins: [ ModalHandler, PaginationHandler, SortDirectionHandler],
    props: {
       deletingTodo: {
           type: Boolean,
           required: true
       },
        viewTodo: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            loading: true,
            todoList: [],
            listOfUsers: [],
            radioOptions: [
                { id: 'id-2', value: 'inbox', label: 'Inbox' },
                { id: 'id-3', value: 'sent', label: 'Sent' },
            ],
            filters: {
                search: '',
                status: 'all',
                sortBy: 'title',
                sortDir: 'asc',
                type: 'inbox',
                page: 1,
                perPage: 10
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    computed: {
        sortedTasks() {
            const mainTasks = this.todoList.filter(task => task.main_task_id === null);
            const subTasks = this.todoList.filter(task => task.main_task_id !== null);
            const sorted = [];

            mainTasks.forEach(mainTask => {
                sorted.push(mainTask);
                subTasks
                    .filter(subTask => subTask.main_task_id === mainTask.id)
                    .forEach(subTask => sorted.push(subTask));
            });

            const remainingSubTasks = subTasks.filter(subTask => !mainTasks.some(mainTask => mainTask.id === subTask.main_task_id));
            sorted.push(...remainingSubTasks);

            return sorted;
        },
    },
    methods: {
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
        getList(filters) {
            this.getTodoList(filters)
        },
        async getListOfActiveUsers() {
            try {
                const {data: response} = await CommonService.getListOfActiveUsers()
                this.listOfUsers = response
            } catch (e) {
                console.error(e)
            }
        },
         async deleteTodo(id) {
            this.$showLoadingMessage();
            this.todoList = this.todoList.filter((todo) => todo.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await ToDoService.deleteTodo(id)
                await this.getTodoList()
            } catch (error) {
                this.$showErrorMessage('The to-do was not deleted. Please try again');
            }
        },
        async getTodoList() {
            try {
                const {data: todoInfo} = await ToDoService.getTodoList(this.filters)
                this.todoList = todoInfo.data
                this.pagination.current_page = todoInfo.current_page
                this.pagination.last_page = todoInfo.last_page
                this.loading = false
            } catch (error) {
                this.$handleErrors(error)
            }
        },
    },
    mounted() {
        if (this.viewTodo) {
            this.radioOptions = [
                { id: 'id-1', value: 'all', label: 'All' },
                { id: 'id-2', value: 'inbox', label: 'Inbox' },
                { id: 'id-3', value: 'sent', label: 'Sent' },
            ]
            this.filters.type = 'all'
        }
        this.getTodoList()
        this.getListOfActiveUsers()
        this.delayedSearch = createDebouncedFunction(() => this.getTodoList(), 500);
    },


}

</script>


<style scoped>

</style>
